var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor"},[_c('quill-editor',{staticClass:"editor",attrs:{"value":_vm.value,"options":_vm.editorOptions},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }